module.exports = __webpack_public_path__ + "images/playlist_640.689ee2f34cdfaad8e6021103e80eb722.png";